"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncIndexSpliterator = AsyncIndexSpliterator;
exports.asyncSplitAt = asyncSplitAt;
exports.default = exports.AsyncSplitAt = void 0;

var _circularBuffer = require("../../internal/circular-buffer");

var _asyncIterable = require("../../internal/async-iterable");

var _iterableIterator = require("../../internal/iterable-iterator");

var _asyncSpliterator = require("../../internal/async-spliterator");

async function* AsyncIndexSpliterator(source, idx) {
  const sourceIterator = source[Symbol.asyncIterator]();
  const fromEnd = idx < 0;
  const offset = Math.abs(idx);
  const buffer = fromEnd ? new _circularBuffer.CircularBuffer(offset) : null;
  let currentPos = 0;
  let yielded = 0;
  let sourceDone = false;

  try {
    let item;
    let value;

    while ((fromEnd || currentPos < idx) && !(item = await sourceIterator.next()).done) {
      currentPos++;
      ({
        value
      } = item);

      if (fromEnd) {
        value = buffer.push(value);
      }

      if (fromEnd && currentPos <= offset) {
        continue;
      } else {
        yield value;
        yielded++;
      }
    }

    if (fromEnd) {
      let i = yielded;

      while (buffer.size && i++ < offset) {
        yield buffer.shift();
      }
    }

    yield _asyncSpliterator.split;

    if (fromEnd) {
      yield* buffer;
    } else {
      while (!(item = await sourceIterator.next()).done) {
        yield item.value;
      }
    }

    sourceDone = true;
  } finally {
    if (!sourceDone) {
      sourceIterator.return && sourceIterator.return();
    }
  }
}

class AsyncSplitAt extends _iterableIterator.IterableIterator {
  constructor(source, idx) {
    super();
    this.source = source;
    this.idx = idx;
    this.partsIterator = null;
    this.firstPart = null;
    this.secondPart = null;
    this.currentIdx = 0;
  }

  async setupFirst() {
    this.partsIterator = this.partsIterator || new _asyncSpliterator.AsyncPartsIterator((await AsyncIndexSpliterator(this.source, this.idx)));
    this.firstPart = this.firstPart || (await this.partsIterator.next()).value;
  }

  next() {
    const self = this;

    switch (this.currentIdx++) {
      case 0:
        return {
          value: async function* () {
            await self.setupFirst();
            yield* self.firstPart;
          }(),
          done: false
        };

      case 1:
        return {
          value: async function* () {
            await self.setupFirst();
            self.secondPart = (await self.partsIterator.next()).value;
            yield* self.secondPart;
          }(),
          done: false
        };

      default:
        return {
          value: undefined,
          done: true
        };
    }
  }

  return() {
    if (this.currentIdx === 1) {
      throw new Error('You must take both parts from splitAt or neither.');
    }

    return {
      value: undefined,
      done: true
    };
  }

}

exports.AsyncSplitAt = AsyncSplitAt;

function* asyncSplitAt(source, idx) {
  yield* new AsyncSplitAt(source, idx);
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncSplitAt, {
  forceSync: true
});

exports.default = _default;